import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import {
  medicalRep,
  PurchaseTeam,
} from "../../../../Data/Tables/ReactstrapTables/BasicTables";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import { Btn } from "../../../../AbstractElements";
import { toast } from "react-toastify";
import api from "../../../../services/api";

interface MedicalRep {
  id: number;
  name: string;
  employeeId: string;
  designation: string;
  contactdetails: string;
  email: string;
  userId: number;
  user?: { email: string; disablestatus: number };
}

export default function PurchaseTeamList() {
  const [purchaseteam, setPurchaseteam] = useState<MedicalRep[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [newStatus, setNewStatus] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPurchaseteam();
  }, []);

  const fetchPurchaseteam = async () => {
    try {
      const response = await api.get(`${baseUrl}purchaseteam/getAllPurchase`);
      setPurchaseteam(response.data.data);
    } catch (error) {
      console.error("Error fetching purchase team data:", error);
    }
  };

  const handleConfirm = (userId: number, status: number) => {
    setSelectedUserId(userId);
    setNewStatus(status);
    setModalOpen(true);
  };

  const updateUserStatus = async () => {
    if (selectedUserId === null || newStatus === null) return;

    const selectedUser = purchaseteam.find(
      (team) => team.userId === selectedUserId
    );
    if (!selectedUser || !selectedUser.user?.email) {
      toast.error("User email not found.");
      return;
    }

    setLoading(true);

    try {
      await axios.put(`${baseUrl}user/disable`, {
        userId: selectedUserId,
        disablestatus: newStatus,
        email: selectedUser.user.email,
      });

      toast.success(
        `User ${newStatus === 1 ? "blocked" : "unblocked"} successfully.`
      );
      fetchPurchaseteam();
    } catch (error) {
      console.error("Error updating user status:", error);
      toast.error("Failed to update user status.");
    } finally {
      setLoading(false);
      setModalOpen(false);
    }
  };

  return (
    <>
      {/* Loading Modal */}
      <Modal isOpen={loading} centered>
        <ModalBody className="text-center">
          <Spinner color="primary" />
          <p className="mt-2">Please wait...</p>
        </ModalBody>
      </Modal>

      <Col sm={12}>
        <Card>
          <CommonCardHeader title="Medical Representative Details" />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px",
            }}
          >
            <Btn
              style={{
                backgroundColor: "blue",
                color: "white",
                padding: "4px 16px",
                borderRadius: "5px",
              }}
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/registeremployee`)
              }
            >
              Add Employee
            </Btn>
          </div>

          <div className="table-responsive">
            <CommonTable
              headData={PurchaseTeam}
              headRowClass="border-bottom-secondary border-top-0"
            >
              {purchaseteam.length > 0 ? (
                purchaseteam.map((team: MedicalRep, index: number) => (
                  <tr key={team.id}>
                    <td>{index + 1}</td>
                    <td>{team.name}</td>
                    <td>{team.employeeId}</td>
                    <td>{team.designation}</td>
                    <td>{team.contactdetails}</td>
                    <td>{team.user?.email || "N/A"}</td>
                    <td>
                      <span
                        className={
                          team.user?.disablestatus === 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {team.user?.disablestatus === 0 ? "Active" : "Blocked"}
                      </span>
                    </td>
                    <td>
                      {team.user?.disablestatus === 0 ? (
                        <Btn
                          color="danger"
                          onClick={() => handleConfirm(team.userId, 1)}
                        >
                          Block
                        </Btn>
                      ) : (
                        <Btn
                          color="success"
                          onClick={() => handleConfirm(team.userId, 0)}
                        >
                          Unblock
                        </Btn>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>No data available</td>
                </tr>
              )}
            </CommonTable>
          </div>
        </Card>

        {/* Confirmation Modal */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
          <ModalHeader toggle={() => setModalOpen(false)}>
            Confirm {newStatus === 1 ? "Blocking" : "Unblocking"}
          </ModalHeader>
          <ModalBody>
            Are you sure you want to {newStatus === 1 ? "block" : "unblock"}{" "}
            this user?
          </ModalBody>
          <ModalFooter>
            <Btn color="danger" onClick={updateUserStatus}>
              Yes, {newStatus === 1 ? "Block" : "Unblock"}
            </Btn>
            <Btn color="secondary" onClick={() => setModalOpen(false)}>
              Cancel
            </Btn>
          </ModalFooter>
        </Modal>
      </Col>
    </>
  );
}
